import React, { Component } from "react";
import App from "../../App";
import { Button } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { withRouter, Link } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import DatePicker from "react-datepicker";
import { getPaginatedList, getList } from "../../services/baseServices";
import { getFormattedDate } from "../../helper/utils";
import Loader from 'react-loader';

import ExportCSVAsync from "../common/ExportCSVAsync";

const headers = [
    {label: "Commission For", key: "transaction_type"},
    {label: "Transaction Id", key: "transaction_id"},
    {label: "Chalan No", key: "chalan_no"},
    {label: "Create Date", key: "collection_date"},
    {lable: "Distributor", key: "warehouse_name"},
    {label: "From Bank", key: "from_bank"},
    {label: "To Bank", key: "to_bank"},
    {label: "Order Count", key: "order_count"},
    {label: "Amount", key: "amount"},
    {label: "Received", key: "is_approved"},
];

var today = new Date()
today.setMonth(today.getMonth()-2)

const loadData = (item) => {
    return {
        transaction_type: item.transaction_type,
        transaction_id: item.transaction_id,
        chalan_no: item.chalan_no,
        warehouse_name: item.warehouse_name,
        amount: item.amount,
        collection_date: getFormattedDate(item.collection_date, "LT Do MMMM YYYY"),
        from_bank: item.from_bank,
        to_bank: item.to_bank,
        order_count: item.order_count,
        is_approved: item.is_approved?"Yes": "No",
    };
};

class List extends Component {
    constructor() {
        super();
        this.state = {
            collections: [],
            isLoading: true,
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: { month:  today.getMonth()+1, year: today.getFullYear() },
            query_params: { month:  today.getMonth()+1, year: today.getFullYear() }, 
            isExporting: false,
            start_date_time: today,
            end_date_time: today,
            distributors: []
        };
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params, {per_page: this.state.per_page, page: this.state.page});
        return params;
    }

    getPaginatedCashCollection = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("bank_transactions/commissions", params)
            .then(res => {
                this.setState({
                    collections: res.data,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }

    componentDidMount() {
        this.getPaginatedCashCollection(this.getQueryParams());
        getList("distributors")
          .then((res) => {
            this.setState({ distributors: res });
          })
          .catch((errMsg) => {});
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        this.setState({...this.state, page: 1, query_params: tempParam}, () => {
            this.getPaginatedCashCollection(this.state.temp_params);
        });
    }

    handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData}, () => {
        });
    }

    handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
            this.getPaginatedCashCollection(this.getQueryParams());
        });
    }

    handleOnApply = (date)=>{
        this.setState({start_date_time: date})
        this.setState({temp_params: {...this.state.temp_params,  month:  date.getMonth()+1, year: date.getFullYear() }})
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Commission List</h2>
                        <div className="ml-auto d-flex">
                            <ExportCSVAsync
                                fileName={
                                    "Agent-Commission-" + getFormattedDate(new Date(), "DD-MM-YYYY") + ".csv"
                                }
                                Url="bank_transactions/agent_commission"
                                headers={headers}
                                params={{
                                    distributor_id: this.state.query_params?.distributor_id,
                                    month: this.state.query_params?.month, 
                                    year: this.state.query_params?.year, 
                                    skip_pagination: true
                                }}
                                loadData={loadData}
                                title="Agent Commission List"
                            />
                        </div>
                    </div>
                    <form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <label htmlFor="status" className="sr-only">
                                Date Range
                            </label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.start_date_time}        
                                    onChange={this.handleOnApply}
                                    dateFormat="MMMM-yyyy"
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    showFourColumnMonthYearPicker
                                    />
                            {/* <DateRangePicker
                                initialSettings={{
                                    startDate: this.state.start_date_time,
                                    endDate: this.state.end_date_time,
                                    maxSpan: {"months": 3},
                                    showDropdowns: true,
                                    locale: {format: "DD/MM/YYYY"},
                                    autoApply: true,
                                }}
                                onApply={(e, picker) => this.handleOnApply(e, picker)}
                            >

                                <input type="text"
                                       value={this.state.start_date_time && this.state.end_date_time ? `${getFormattedDate(this.state.start_date_time, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time, "DD/MM/YYYY")}` : ''}
                                       style={{textAlign: 'left', minWidth: '150px'}}
                                       placeholder={"Select date range"}
                                       className="form-control form-control-sm"/>
                            </DateRangePicker> */}
                        </div>
                        <div className="form-group mr-3">
                            <label htmlFor="distributor_id" className="sr-only">
                                Distributor
                            </label>
                            <select
                                id="distributor_id"
                                name="distributor_id"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    this.handleOnFieldChange(e);
                                }}
                            >
                            <option value="">--Select Distributor--</option>
                            {this.state.distributors?.length > 0
                                ? this.state.distributors.map((item, i) => {
                                    return (
                                    <option key={i} value={item.id}>
                                        {item.name}
                                    </option>
                                    );
                                })
                                : ""}
                            </select>
                        </div>
                        <div className="form-group mr-3">
                            <label htmlFor="transaction_type" className="sr-only">
                                Type
                            </label>
                            <select
                                id="transaction_type"
                                name="transaction_type"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    this.handleOnFieldChange(e);
                                }}
                            >
                            <option value="">--Select Type--</option>
                            <option value={1}>Agent Commission</option>
                            <option value={2}>Sub-Agent Commission</option>
                            </select>
                        </div>
                        <Button
                            size="sm"
                            type={`submit`}
                            onClick={this.handleOnSearch}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </form>
                    <Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Commission For</th>
                                        <th>Transaction Id</th>
                                        <th>Chalan No</th>
                                        <th>Create Date</th>
                                        <th>Distributor</th>
                                        <th>From Bank </th>
                                        <th>To Bank </th>
                                        <th>Amount</th>
                                        <th>Order Count</th>
                                        <th>Received</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.collections?.length > 0 ? (
                                        this.state.collections.map((c, index) => {
                                            return (
                                                <tr key={index}>
                                                <td>
                                                    <div className="order-item">
                                                        {c.transaction_type}
                                                    </div>
                                                </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.transaction_id}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.chalan_no}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {getFormattedDate(c.collection_date, "DD-MM-YYYY")}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.warehouse_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.from_bank}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.to_bank}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.amount}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.order_count}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.is_approved?"Yes":"No"}
                                                        </div>
                                                    </td>
                                                    <td>
                                                         <Link
                                                            to={`${process.env.PUBLIC_URL}/commssion-transactions/details/${c.transaction_id}`}
                                                            className="btn btn-sm btn-outline-secondary"
                                                        >
                                                            Details
                                                        </Link>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                {" "}
                                                <h5>No Order Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.per_page}
                                    totalItemsCount={this.state.total_data}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>

                    </Loader>
                </div>
                <ToastsContainer store={ToastsStore}/>
            </App>
        );
    }
}

export default withRouter(List);
